/**
 * Partify YMM Paint Filter
 * Guards #variant-selector against stale YMM paint-code narrowing.
 * Shopify product variants remain the canonical paint-code source on PDPs.
 */
(function () {
	"use strict";

	const ALWAYS_SHOW = [
		"unpainted",
		"custom paint code",
		"we'll contact you",
	];
	const PAINT_MATCH_SENTINELS = [
		".vin",
		"vin",
		"match paint by vin",
		"match by vin",
		"paint code match by vin",
		"match paint by license plate",
		"match by license plate",
		"match paint by license",
		"match by license",
		"paint code match by license plate",
	];

	function getCurrentVehicleHandles() {
		try {
			const terms = JSON.parse(localStorage.getItem("searchTerms") || "[]");
			if (!Array.isArray(terms) || !terms.length || !terms[0]) return [];
			return window.PartifyTwoToneRuleResolver.vehicleHandles(terms[0]);
		} catch (e) {
			return [];
		}
	}

	function getPaintCodesForVehicle() {
		const map = window.__PARTIFY_YMM_PAINT_MAP;
		if (!map || !Object.keys(map).length) return null;
		const handles = getCurrentVehicleHandles();
		const matchedHandle = handles.find(function (handle) {
			return Array.isArray(map[handle]) && map[handle].length;
		});
		return matchedHandle ? map[matchedHandle] : null;
	}

	function getTwoToneRuleConfig() {
		const config = window.__PARTIFY_TWO_TONE_PAINT_RULES;
		return config && Array.isArray(config.rules) ? config.rules : [];
	}

	function isTwoToneSelected() {
		if (typeof twoToneSelected === "boolean") return twoToneSelected;
		return false;
	}

	function isManualPaintModeSelected() {
		const manualRadio = document.getElementById("checkbox-select-paint-option");
		return !!(manualRadio && manualRadio.checked && !manualRadio.disabled);
	}

	function getTwoTonePaintCodesForVehicle() {
		const rules = getTwoToneRuleConfig();
		if (!rules.length) return null;
		if (!isTwoToneSelected() || !isManualPaintModeSelected()) return null;

		const handles = getCurrentVehicleHandles();
		if (!handles.length) return null;

		const selected = window.PartifyTwoToneRuleResolver.selectRule(rules, handles);
		return selected && selected.codes.length ? selected.codes : null;
	}

	function isAlwaysVisible(text) {
		const t = (text || "").toLowerCase();
		return ALWAYS_SHOW.some(function (p) {
			return t.indexOf(p) !== -1;
		});
	}

	function isPaintMatchSentinel(text) {
		const t = String(text || "").toLowerCase().trim();
		if (!t) return false;
		return PAINT_MATCH_SENTINELS.some(function (p) {
			return t === p || t.indexOf(p) !== -1;
		});
	}

	function showAllOptions(select) {
		Array.from(select.options).forEach(function (opt) {
			if (opt.dataset.partifyPaintMatchOriginalDisabled) {
				opt.disabled = opt.dataset.partifyPaintMatchOriginalDisabled === "true";
				delete opt.dataset.partifyPaintMatchOriginalDisabled;
			}
			opt.hidden = false;
		});
	}

	function getOptionPaintMatchText(opt) {
		return [
			opt.text || "",
			opt.label || "",
			opt.getAttribute("data-variant-title") || "",
			opt.getAttribute("data-variant-sku") || "",
		].join(" ");
	}

	function normalizePaintCodes(paintCodes) {
		const normalized = new Set();
		paintCodes.forEach(function (c) {
			const code = (c || "").toLowerCase().trim();
			if (!code) return;
			normalized.add(code);
			if (code.indexOf("wa") === 0 && code.length > 2) {
				normalized.add(code.slice(2));
			}
		});
		return normalized;
	}

	function optionMatchesCodes(opt, normalized) {
		const optText = (opt.text || "").toLowerCase().trim();
		return Array.from(normalized).some(function (code) {
			return (
				optText === code ||
				optText.startsWith(code + " ") ||
				optText.startsWith(code + "+")
			);
		});
	}

	function optionIsFilteredOut(opt) {
		return opt.hidden;
	}

	function wouldHideProductPaintCode(select, normalized) {
		return Array.from(select.options).some(function (opt) {
			if (!opt.value || opt.disabled || isAlwaysVisible(opt.text)) return false;
			return !optionMatchesCodes(opt, normalized);
		});
	}

	function applyYmmPaintFilter(select) {
		const paintCodes = getPaintCodesForVehicle();
		if (!paintCodes || !paintCodes.length) return;

		// Paint codes in __PARTIFY_YMM_PAINT_MAP can be handles with a GM "WA"
		// prefix (e.g. "wa102v") while dropdown labels show the bare code ("102V").
		const normalized = normalizePaintCodes(paintCodes);
		if (!normalized.size) return;

		// The YMM paint-code map is an inferred helper, not an authoritative product
		// exclusion list. If it would hide any Shopify variant option, keep the full
		// product list so partial or restored vehicle state cannot remove valid codes.
		if (wouldHideProductPaintCode(select, normalized)) return;

		Array.from(select.options).forEach(function (opt) {
			if (!opt.value || opt.disabled || isAlwaysVisible(opt.text)) {
				opt.hidden = false;
				return;
			}
			const match = optionMatchesCodes(opt, normalized);
			opt.hidden = !match;
		});
	}

	function applyTwoTonePaintFilter(select) {
		const paintCodes = getTwoTonePaintCodesForVehicle();
		if (!paintCodes || !paintCodes.length) return;

		const normalized = normalizePaintCodes(paintCodes);
		if (!normalized.size) return;
		Array.from(select.options).forEach(function (opt) {
			if (!opt.value || opt.disabled || isAlwaysVisible(opt.text)) {
				opt.hidden = false;
				return;
			}
			if (optionIsFilteredOut(opt)) return;
			opt.hidden = !optionMatchesCodes(opt, normalized);
		});
	}

	function clearProductFormVariantIds() {
		const forms = Array.from(
			document.querySelectorAll(
				'form[action*="/cart/add"], #cnm-form, #product-form',
			),
		);
		forms.forEach(function (form) {
			form.querySelectorAll('[name="id"]').forEach(function (input) {
				input.value = "";
			});
			if (form.action) form.action = "/cart/add?id=";
		});
	}

	function clearSubmittedPaintMatchSentinels() {
		document
			.querySelectorAll(
				'input[name="properties[Paint Code]"], input[name="properties[Touch-Up Color]"]',
			)
			.forEach(function (input) {
				if (isPaintMatchSentinel(input.value)) input.value = "";
			});
	}

	function excludeTwoTonePaintMatchOptions(select) {
		if (!isTwoToneSelected()) return;
		Array.from(select.options).forEach(function (opt) {
			if (!opt.value || !isPaintMatchSentinel(getOptionPaintMatchText(opt))) return;
			if (!opt.dataset.partifyPaintMatchOriginalDisabled) {
				opt.dataset.partifyPaintMatchOriginalDisabled = opt.disabled
					? "true"
					: "false";
			}
			opt.hidden = true;
			opt.disabled = true;
		});
	}

	function resetFilteredSelection(select) {
		const current = select.options[select.selectedIndex];
		if (current && optionIsFilteredOut(current)) {
			const firstVisible = Array.from(select.options).find(function (o) {
				return !optionIsFilteredOut(o);
			});
			if (firstVisible) {
				select.value = firstVisible.value;
				clearProductFormVariantIds();
				clearSubmittedPaintMatchSentinels();
				if (typeof disableAddToCartButton === "function") {
					disableAddToCartButton();
				}
			}
		}
	}

	function filterVariantDropdown() {
		const select = document.getElementById("variant-selector");
		if (!select || !select.options.length) return;

		showAllOptions(select);
		applyYmmPaintFilter(select);
		applyTwoTonePaintFilter(select);
		excludeTwoTonePaintMatchOptions(select);
		resetFilteredSelection(select);
	}

	document.addEventListener("variantsUpdated", function () {
		requestAnimationFrame(function () {
			requestAnimationFrame(filterVariantDropdown);
		});
	});

	document.addEventListener("DOMContentLoaded", function () {
		requestAnimationFrame(filterVariantDropdown);
	});

	document.addEventListener("change", function (event) {
		if (
			event.target?.matches?.(".fitment-radio, input[name='select_paint_option']")
		) {
			requestAnimationFrame(filterVariantDropdown);
		}
	});

	window.addEventListener("searchTermsUpdated", function () {
		requestAnimationFrame(filterVariantDropdown);
	});

	window.addEventListener("partify:vehicle:changed", function () {
		requestAnimationFrame(filterVariantDropdown);
	});
})();
